import * as localforage from 'localforage';
import { IStorage } from './IStorage';

/**
 * The browser storage class
 * 
 * @export
 * @class Storage
 */
export default class LocalForageStorage implements IStorage {
    /**
     * Creates an instance of Storage.
     * 
     * @param {string} name
     * 
     * @memberOf Storage
     */
    constructor(private name: string) {
        localforage.config({
            name
        });
     }

    /**
     * Removes an item with the given key from storage
     * 
     * @param {string} key
     * @returns {Promise<void>}
     * 
     * @memberOf Storage
     */
    remove(key: string): Promise<void> {
        return localforage.removeItem(`${key}`);
    }

    /**
     * Sets the value of an item in storage based on the given key
     * 
     * @template TValue
     * @param {string} key
     * @param {TValue} item
     * @returns {Promise<TValue>}
     * 
     * @memberOf Storage
     */
    set<TValue>(key: string, item: TValue): Promise<TValue> {
        return localforage.setItem(`${key}`, item);
    }

    /**
     * Gets the item with the given key from storage
     * 
     * @template TValue
     * @param {string} key
     * @returns {Promise<TValue>}
     * 
     * @memberOf Storage
     */
    get<TValue>(key: string): Promise<TValue> {
        return localforage.getItem(`${key}`);
    }
}


// WEBPACK FOOTER //
// ./src/LocalForageStorage.ts